import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from '@blueprintjs/core'
import { ResponsiveBlock } from 'client/components/LayoutNew/components/ResponsiveBlock/ResponsiveBlock'
import { ClientLocaleNS } from 'lib/constants/locales'

import { FaqListItem } from './components/FaqListItem/FaqListItem'

type TProps = {}

const CONTENT_MAP = [2, 5, 4, 1, 2, 1]

const FaqBlock: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.MainPage)

  return (
    <ResponsiveBlock className="max-2xl:px-5">
      <div className="flex w-full items-center justify-between gap-12 py-20 text-text-white">
        <div className="flex">
          <Text
            tagName="h1"
            className="font-title---32px whitespace-pre uppercase md:font-title---50px lg:font-title---70px 2xl:font-title---100px"
          >
            {t('faq_block.title')}
          </Text>
        </div>
        <div className="flex flex-1 items-center justify-center" />
      </div>
      <ul className="flex w-full flex-col">
        {CONTENT_MAP.map((elementsCount, index) => {
          return <FaqListItem elementsCount={elementsCount} index={index} />
        })}
      </ul>
    </ResponsiveBlock>
  )
}

export { FaqBlock }
